import { Method } from '../../data/DataUtils.js';
import * as DataUtils from '../../data/DataUtils.js';
import * as DTOs from '../DTOs/TorneoEtapasDTOs.js';

export const DeleteItem = async (idPadre, idItem) => {
  return await DataUtils.SaveObject(
    Method.DELETE,
    'torneos/' + idPadre + '/lista_etapas/' + idItem,
    null
  );
};

export const GetItem = async (idPadre, idItem) => {
  return DataUtils.FetchObject('torneos/' + idPadre + '/lista_etapas/' + idItem);
};

export const GetListaItems = async (idPadre) => {
  return DataUtils.FetchLista('torneos/' + idPadre + '/lista_etapas');
};

export const PostItem = async (idPadre, datosItem) => {
  const response = await DataUtils.SaveObject(
    Method.POST,
    'torneos/' + idPadre + '/lista_etapas',
    DTOs.saveItem(datosItem)
  );
  // El backend puede devolver un objeto con { status, id, errores, ... }
  // o directamente el id como string/número
  if (response) {
    // Si es un objeto con campo id, extraerlo
    if (typeof response === 'object' && response.id) {
      return response.id;
    }
    // Si es directamente el id (string o número)
    return response;
  }
  return null;
};

export const PutItem = async (idPadre, datosItem) => {
  await DataUtils.SaveObject(
    Method.PUT,
    'torneos/' + idPadre + '/lista_etapas/' + datosItem.id,
    DTOs.saveItem(datosItem)
  );
  return datosItem.id;
};
